import { render, staticRenderFns } from "./OrderRecordDetails.vue?vue&type=template&id=f5e10938&scoped=true&"
import script from "./OrderRecordDetails.vue?vue&type=script&lang=js&"
export * from "./OrderRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecordDetails.vue?vue&type=style&index=0&id=f5e10938&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e10938",
  null
  
)

export default component.exports